export default __webpack_public_path__ + "static/media/event-passenger-terminal-expo.8a55144f.jpg";